<p>Lists all emails sent via the Foresight system. Note that bounced emails should be prevented
	(investigated with the customer in question) because too many bounces will cause a low reputation score
	and cause the sending account to be suspended. Complained status is even worse, indicating that a customer
	reported the email as spam.</p>
<div class="mb-3">
	<label>
		<input type="checkbox" [(ngModel)]="noDelivered" (ngModelChange)="refreshTable()">
		Exclude successful deliveries
	</label>
</div>
@if (filters.asset?.name) {
	<div>
		Asset: {{filters.asset?.name}}
		<i (click)="removeFilter('asset')" class="icon-minus-circled clickable"></i>
	</div>
}
@if (!filters.asset) {
	<div>
		<label>Filter to asset:</label>
		<select [(ngModel)]="selectedAsset" (ngModelChange)="FilterAsset($event)" class="form-control ms-2">
			<option [ngValue]="{ asset_id: 0, asset_name: 'No asset' }">No asset</option>
			@for (asset of assetList; track asset) {
				<option [ngValue]="asset">{{asset.fleet_name}} / {{asset.asset_name}} ({{asset.obcu_serial_number}})</option>
			}
		</select>
	</div>
}

@if (pageLogs === undefined) {
	<div class="loading-status">
		<div class="logo-spin"></div>
		Loading logs...
	</div>
}

@if (pageLogs && !pageLogs.length) {
	<div class="loading-status">
		No logs found
	</div>
}

@if (pageLogs && pageLogs.length > 0) {
	<table class="log compact mt-3" [class.loading]="pageLoading">
		<thead>
			<tr>
				<th>Timestamp</th>
				<th>Recipient</th>
				<th>Subject</th>
				<th>Status</th>
				<th>Asset</th>
			</tr>
		</thead>
		@for (email of pageLogs; track email) {
			<tbody>
				<tr>
					<td>
						<span title="{{email.timestamp}}">
							<span>{{email.timestamp | datetime : "localshort"}}</span>
						</span>
					</td>
					<td>{{email.recipient}}</td>
					<td>{{email.subject}}</td>
					<td [style.color]="email.status | sentemailstatuscolor">{{email.status}}</td>
					<td class="nowrap">
						@if (email.asset_id) {
							<a href="javascript:void(0)" (click)="SelectAsset(email)">{{email.asset_name}}</a>
						}
					</td>
				</tr>
			</tbody>
		}
	</table>
	<ngb-pagination [collectionSize]="totalEmails" [pageSize]="itemsPerPage" [(page)]="currentPage" (pageChange)="updatePage()" [maxSize]="10" [directionLinks]="true"
		[rotate]="true"></ngb-pagination>
}
